/**
 * ShipmentRecordOpener - Abre a ficha oficial do destinatário/registro vinculado à remessa.
 *
 * Reaproveita as fichas existentes (O.S., Negócio, Tarefa, Cliente, Veículo e Pessoa);
 * apenas uma fica aberta por vez. Nenhuma ficha paralela é criada.
 *
 * RELEASE: 2026-10-16 v1.0.0 - Versão inicial.
 */
import { ServiceOrderDetailsModal } from '@/components/service-orders/ServiceOrderDetailsModal';
import { DealDetailsModalPremium } from '@/components/crm/deals/modal/DealDetailsModalPremium';
import { TaskDetailsModal } from '@/components/tasks/modal/TaskDetailsModal';
import { CustomerDetailsModalPremium } from '@/components/crm/customers/modal/CustomerDetailsModalPremium';
import { VehicleDetailsModalPremium } from '@/components/vehicles/modal/VehicleDetailsModalPremium';
import { PersonDetailsModal } from '@/components/persons/PersonDetailsModal';
import { usePersonsList } from '@/hooks/usePersons';

export interface ShipmentRecordRef {
  type: string;
  id: string;
  /** Nome usado para localizar a pessoa pela listagem oficial */
  name?: string;
}

/** Ficha da Pessoa: localiza o cadastro pela RPC oficial de Pessoas (busca pelo nome). */
function PersonOpener({ id, name, onClose }: { id: string; name: string; onClose: () => void }) {
  const { data } = usePersonsList({ search: name.slice(0, 100), role: 'all', status: 'all', page: 1, pageSize: 50 });
  const person = data?.items.find((p) => p.id === id) ?? null;
  return <PersonDetailsModal person={person} open={!!person} onOpenChange={(o) => !o && onClose()} />;
}

export function ShipmentRecordOpener({ record, onClose }: { record: ShipmentRecordRef | null; onClose: () => void }) {
  const idOf = (t: string) => (record?.type === t ? record.id : null);
  const close = (o: boolean) => { if (!o) onClose(); };
  return (
    <>
      <ServiceOrderDetailsModal serviceOrderId={idOf('service_order')} open={!!idOf('service_order')} onOpenChange={close} />
      <DealDetailsModalPremium dealId={idOf('deal')} open={!!idOf('deal')} onOpenChange={close} />
      <TaskDetailsModal taskId={idOf('task')} open={!!idOf('task')} onOpenChange={close} />
      <CustomerDetailsModalPremium customerId={idOf('customer')} open={!!idOf('customer')} onOpenChange={close} />
      <VehicleDetailsModalPremium vehicleId={idOf('vehicle')} open={!!idOf('vehicle')} onOpenChange={close} />
      {record?.type === 'person' && <PersonOpener id={record.id} name={record.name ?? ''} onClose={onClose} />}
    </>
  );
}
